<div class="overlay">
	<app-fm-logo [prefix]="prefix" class="margin-bottom-xxs"></app-fm-logo>

	<div *ngIf="isBrowserUnsupported; else browserSupported">
		<div>
			<p>IKEA Media Content Centre does not support Internet Explorer 11.</p>
			<p>Recommended browsers are Chrome, Edge and Safari.</p>
		</div>
	</div>

	<ng-template #browserSupported>
		<div class="text-center">
			IKEA Media Content Centre <span class="dot">.</span
			><span class="dot dot-2">.</span><span class="dot dot-3">.</span>
		</div>
	</ng-template>
</div>
